import React from 'react';

import type { NotificationOffset } from '../../ai/reminder-automation/NotificationOffsetBuilder';
import {
  defaultOffset,
  NotificationOffsetBuilder,
} from '../../ai/reminder-automation/NotificationOffsetBuilder';

interface ReminderNotifyOnProps {
  offsets: NotificationOffset[];
  onOffsetsChange: (offsets: NotificationOffset[]) => void;
}

export function ReminderNotifyOn({ offsets, onOffsetsChange }: ReminderNotifyOnProps) {
  const displayOffsets = offsets.length > 0 ? offsets : [{ ...defaultOffset }];

  return <NotificationOffsetBuilder offsets={displayOffsets} onChange={onOffsetsChange} />;
}
